__turbopack_context__.v({
  "circle": "Confetti-module__AqXjha__circle",
  "container": "Confetti-module__AqXjha__container",
  "particle": "Confetti-module__AqXjha__particle",
  "rotation-0": "Confetti-module__AqXjha__rotation-0",
  "rotation-1": "Confetti-module__AqXjha__rotation-1",
  "rotation-2": "Confetti-module__AqXjha__rotation-2",
  "rotation-3": "Confetti-module__AqXjha__rotation-3",
  "rotation-4": "Confetti-module__AqXjha__rotation-4",
  "rotation-5": "Confetti-module__AqXjha__rotation-5",
  "screen": "Confetti-module__AqXjha__screen",
  "x-axis": "Confetti-module__AqXjha__x-axis",
  "y-axis": "Confetti-module__AqXjha__y-axis",
});
